import http from './http';
import { listResource } from './listResource';

// Listar calentamientos con paginación, búsqueda y ordenamiento
export async function listPreparations(options = {}) {
  return listResource('/preparations', options);
}

// Activar/Desactivar Calentamiento
export const updatePreparationStatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
  http.patch(`/preparations/${id}/status`, { is_active: isActive });

// Eliminar Calentamiento
export const deletePreparation = (id) => http.delete(`/preparations/${id}`);

// Obtener un calentamiento por su ID
export async function getPreparationById(id) {
  const res = await http.get(`/preparations/${id}`);
  return res.data?.data ?? res.data;
}

// Crear un nuevo calentamiento
export async function createPreparation(payload) {
  const res = await http.post('/preparations', payload);
  return res.data?.data ?? res.data;
}

// Actualizar un calentamiento existente
export async function updatePreparation(id, payload) {
  const res = await http.put(`/preparations/${id}`, payload);
  return res.data?.data ?? res.data;
}

// Subir archivo de imagen para calentamiento
export async function uploadPreparationMedia(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await http.post('/files/upload/warm-up', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const responseData = res.data?.data ?? res.data;
  return {
    url: responseData?.url ?? responseData,
    preview_url: responseData?.preview_url ?? null,
  };
}

// Verificar si un título ya existe
export async function checkPreparationTitleExists(title, excludeId = null) {
  try {
    const { items } = await listPreparations({ search: title });
    const exists = items?.some(
      (preparation) =>
        preparation.title?.toLowerCase() === title?.toLowerCase() &&
        preparation.id !== excludeId
    );
    return exists;
  } catch (error) {
    console.error('Error al verificar título:', error);
    return false;
  }
}

// Obtener calentamientos alternativos de un calentamiento
export async function getPreparationAlternatives(preparationId) {
  const res = await http.get(`/preparations/${preparationId}/alternatives`);
  return res.data?.items ?? res.data ?? [];
}

export async function getPreparationCatalog(preparationType) {
  const res = await http.get(`/preparations/catalog/${preparationType}`);
  return res.data?.items ?? res.data ?? [];
}

